import { render, staticRenderFns } from "./userCenterNav.vue?vue&type=template&id=5b5e11aa&scoped=true"
import script from "./userCenterNav.vue?vue&type=script&lang=js"
export * from "./userCenterNav.vue?vue&type=script&lang=js"
import style0 from "./userCenterNav.vue?vue&type=style&index=0&id=5b5e11aa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b5e11aa",
  null
  
)

export default component.exports